import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import FormGroup from "features/shared/forms/components/FormGroup";
import { useTranslation } from "react-i18next";
import {
  getTranslatedText,
  getTranslatedTooltip,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import FileInput from "features/shared/forms/components/FileInput";

const FileBoxMultipleField = ({
  descriptor,
  formHandler
}: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const {
    bindUncontrolledField,
    errors,
  } = { ...formHandler };

  // render
  return (
    <div className={descriptor.className}>
      <FormGroup
        labelText={getTranslatedText(descriptor, "label", t)}
        validationError={errors ? errors[descriptor.name] : undefined}
        tooltip={getTranslatedTooltip(descriptor, t)}
      >
        <FileInput
          id={descriptor.name}
          multiple
          {...bindUncontrolledField(descriptor.name)}
          defaultText={getTranslatedText(descriptor, "placeholder", t)}
        />
      </FormGroup>
    </div>
  );
};

export default FileBoxMultipleField;
